import React from 'react';

const HeadingBlock = ({ block, onChange }) => {
  return (
    <div>
      <select value={block.level || 'h2'} onChange={(e) => onChange({ ...block, level: e.target.value })}>
        <option value="h1">H1</option>
        <option value="h2">H2</option>
        <option value="h3">H3</option>
        <option value="h4">H4</option>
        <option value="h5">H5</option>
        <option value="h6">H6</option>
      </select>
      <input
        type="text"
        placeholder="Heading text"
        value={block.content}
        onChange={(e) => onChange({ ...block, content: e.target.value })}
      />
    </div>
  );
};

export default HeadingBlock;
